import { DistanceUnit } from './programs.js';
export var BenchmarkType;
(function (BenchmarkType) {
    BenchmarkType["WEIGHT"] = "weight";
    BenchmarkType["TIME"] = "time";
    BenchmarkType["REPS"] = "reps";
    BenchmarkType["DISTANCE"] = "distance";
    BenchmarkType["OTHER"] = "other";
})(BenchmarkType || (BenchmarkType = {}));
export { DistanceUnit };
//# sourceMappingURL=benchmarkTemplates.js.map